import {call, put, takeLatest} from 'redux-saga/effects';
import dashboardActions from '../actions/dashboard.actions';
import DashboardApi from '../api/DashboardApi';
import {handleSagaError, handleSagaTrackEvent} from './utils/CommonUtils';

function* fetchEarningsData(action) {
    try {
        const earnings = yield call(DashboardApi.getEarningsData, action.payload);
        yield put(dashboardActions.getEarningsDataSuccess({earnings}));
    } catch (e) {
        yield handleSagaError(e, dashboardActions.getEarningsDataFailed(e));
    }
}

function* fetchProducts(action) {
    try {
        const products = yield call(DashboardApi.getProducts, action.payload);
        yield put(dashboardActions.getProductsSuccess({products}));
        const resData = (products && products.data) || {};
        yield handleSagaTrackEvent(
            action.payload,
            {paging: resData.paging},
            {
                eventCategory: 'MediaCreator',
                eventAction: 'FetchBrowseGames'
            }
        );
    } catch (e) {
        yield handleSagaError(e, dashboardActions.getProductsFailed(e));
    }
}

function* fetchEarnedProducts(action) {
    try {
        const earnedProducts = yield call(DashboardApi.getEarnedProducts, action.payload);
        yield put(dashboardActions.getEarnedProductsSuccess({earnedProducts}));
    } catch (e) {
        yield handleSagaError(e, dashboardActions.getEarnedProductsFailed(e));
    }
}

function* dashboardSaga() {
    yield takeLatest(dashboardActions.TYPES.GET_EARNINGS_DATA, fetchEarningsData);
    yield takeLatest(dashboardActions.TYPES.GET_PRODUCTS, fetchProducts);
    yield takeLatest(dashboardActions.TYPES.GET_EARNED_PRODUCTS, fetchEarnedProducts);
}

export default dashboardSaga;
